import { PrincipleViolationTypeCell } from "../cell";
import { language } from "language/default";
const principlesWidgetLang = language.en.widgets.principlesTable;
export const unGlobalCompactPrinciplesColDefs = [
    {
        cellRenderer: PrincipleViolationTypeCell,
        field: "violationStatus",
        headerName: ""
    },
    {
        field: "principle",
        headerName: principlesWidgetLang.principles,
        width: 80
    },
    {
        field: "description",
        headerName: principlesWidgetLang.description
    },
    {
        field: "violationSource",
        headerName: principlesWidgetLang.sourceOfViolation,
        width: 160
    }
];
